import {
  GroupBy,
  AggregationDefinition,
  AggregationDefinitions,
  BookType,
} from '@common/types/aggregationDefinitions';

type DetailsAggregationType = 'sum' | 'ignore';
type DetailsAggregationDefinition = Record<string, DetailsAggregationType>;
export const defaultDetailsTotalAggregationDefinition: DetailsAggregationDefinition = {
  STATE_PERM_MODS: 'ignore',
  STATE_TEMP_MODS: 'ignore',
};

export const totalDetailsAggregationDefinitions: AggregationDefinitions = {
  default: {
    default: defaultDetailsTotalAggregationDefinition,
    US_SUMMARY: {
      // STATE_CUR_TAX_ADJ: 'ignore',  //11/21/23 Prakash - TLS-11642 commented to perform aggregation for this line on report.
      // CREDIT: 'ignore', //12/5/23 Prakash - TLS-11642 commented to perform aggregation for this line on report.
      DEF_CREDIT: 'ignore',
      STATE_TEMP_MODS: 'ignore',
    },
  },
  CTT: {
    default: {},
    TED_NON_US_GAAP: {
      G2S_NONREV_DIFF: 'ignore',
      G2S_REV_DIFF: 'ignore',
      PERM_DIFF: 'ignore',
      TEMP_DIFF: 'ignore',
    },
    TED_NON_US_STAT: {
      G2S_NONREV_DIFF: 'ignore',
      G2S_REV_DIFF: 'ignore',
      PERM_DIFF: 'ignore',
      TEMP_DIFF: 'ignore',
    },
  },
};
const ignoreCurrencyAggregationDefinitions: AggregationDefinition = {
  FUNC_CURRENCY: 'ignore',
};
export const getTotalDetailsAggregationDefinition = (
  reportLineType: string,
  aggregateBy: GroupBy,
  bookType: BookType,
  ignoreCurrency?: boolean
) => ({
  ...totalDetailsAggregationDefinitions.default.default,
  ...(totalDetailsAggregationDefinitions.default[bookType] || {}),
  ...(totalDetailsAggregationDefinitions[aggregateBy]?.default || {}),
  ...(totalDetailsAggregationDefinitions[aggregateBy]?.[bookType] || {}),
  ...(ignoreCurrency ? ignoreCurrencyAggregationDefinitions : {}),
})[reportLineType];
